module.exports = __webpack_public_path__ + "static/img/Chelion_H5.808bc7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/Chelion_H5.png
// module id = qIgG
// module chunks = 34